import { Handle, Position } from '@xyflow/react'
import { selectedBorder, activeBorder } from './selectedBorder.js'

/**
 * LiveLinkNode — represents the real-time ARKit blendshape stream from Convorcher.
 * Acts as a source node in the Face animation blueprint.
 * When connected to Final Pose (directly or via Blend), HeadModel applies
 * the AudioAnimationBuffer at the evaluated weight.
 *
 * Internal sentinel: data.clipName = '__livelink__'
 */
export function LiveLinkNode({ data, selected }) {
  const weight  = data._debugWeight ?? 0
  const active  = weight > 0.001

  return (
    <div style={{
      background: selected ? '#0f2020' : '#091818',
      border: `2px solid ${selected ? selectedBorder('#185040') : active ? activeBorder('#185040') : '#185040'}`,
      borderRadius: 6,
      padding: '10px 14px',
      minWidth: 170,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 12,
    }}>
      {/* Title */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
        <span style={{ fontSize: 15 }}>📡</span>
        <span style={{ color: '#40d0a0', fontWeight: 'bold', fontSize: 11, letterSpacing: 0.5 }}>LIVE LINK</span>
        {active && (
          <span style={{ color: '#30e0a0', fontSize: 9, marginLeft: 'auto', letterSpacing: 0.3 }}>
            ● {(weight * 100).toFixed(0)}%
          </span>
        )}
        {!active && (
          <span style={{ color: '#305040', fontSize: 9, marginLeft: 'auto' }}>○ idle</span>
        )}
      </div>

      {/* Source label */}
      <div style={{ color: '#336650', fontSize: 10, marginBottom: 8 }}>
        ARKit · 52 blendshapes
      </div>

      {/* Weight bar */}
      <div style={{ height: 3, background: '#0a1a14', borderRadius: 2, overflow: 'hidden' }}>
        <div style={{
          width: `${weight * 100}%`,
          height: '100%',
          background: active ? '#30e0a0' : '#185040',
          transition: 'width 0.1s linear',
        }} />
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="anim"
        style={{ background: active ? '#30e0a0' : '#185040', width: 10, height: 10 }}
      />
    </div>
  )
}
